/** Shared discover-feed card chrome (Mantine + CSS vars). */
export const FEED_CARD_HOVER = {
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  '@media (min-width: 769px)': {
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)'
    }
  }
} as const;

export const FEED_ACTION_BAR_SX = {
  borderTop: '1px solid var(--gs-border)',
  backgroundColor: 'var(--gs-bg-2)',
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 12,
  '@media (max-width: 575px)': {
    position: 'sticky',
    bottom: 0,
    zIndex: 5,
    paddingTop: 10,
    paddingBottom: 'max(10px, env(safe-area-inset-bottom))',
    paddingLeft: 14,
    paddingRight: 14,
    boxShadow: '0 -4px 20px rgba(0,0,0,0.35)',
    backdropFilter: 'blur(8px)'
  }
} as const;

/** Vertical video on narrow viewports (Discover consumption). */
export const FEED_VIDEO_MEDIA_SX = {
  width: '100%',
  aspectRatio: { base: '9 / 16', sm: '16 / 9' },
  maxHeight: { base: 'min(85dvh, 720px)', sm: 'none' },
  backgroundColor: '#000'
} as const;
